/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: nJ1Nn58LcfAm7wemZm71QH
// Component: MFZGD62dYS3p
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/projectcss
import sty from "./PlasmicOp1WebBgSpaceButton.module.css"; // plasmic-import: MFZGD62dYS3p/css
import image69J1Gn9IoaMnpw from "./images/image69.svg"; // plasmic-import: j1GN9IoaMnpw/picture

createPlasmicElementProxy;

export const PlasmicOp1WebBgSpaceButton__VariantProps = new Array("isSelected");

export const PlasmicOp1WebBgSpaceButton__ArgProps = new Array(
  "onClick",
  "dockButtonIcon",
  "pagePath"
);

const $$ = {};

function PlasmicOp1WebBgSpaceButton__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          dockButtonIcon: {
            src: image69J1Gn9IoaMnpw,
            fullWidth: 1,
            fullHeight: 1,
            aspectRatio: undefined
          }
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "isSelected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.isSelected
      }
    ],

    [$props, $ctx, $refs]
  );
  const currentUser = useCurrentUser?.() || {};
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_nJ1Nn58LcfAm7wemZm71QH",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        { [sty.rootisSelected]: hasVariant($state, "isSelected", "isSelected") }
      )}
      onClick={async event => {
        const $steps = {};
        $steps["runOnClick"] = true
          ? (() => {
              const actionArgs = { eventRef: $props["onClick"] };
              return (({ eventRef, args }) => {
                return eventRef?.(...(args ?? []));
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["runOnClick"] != null &&
          typeof $steps["runOnClick"] === "object" &&
          typeof $steps["runOnClick"].then === "function"
        ) {
          $steps["runOnClick"] = await $steps["runOnClick"];
        }
      }}
    >
      <div
        data-plasmic-name={"iconWrapper"}
        data-plasmic-override={overrides.iconWrapper}
        className={classNames("all", sty.iconWrapper, {
          [sty.iconWrapperisSelected]: hasVariant(
            $state,
            "isSelected",
            "isSelected"
          )
        })}
      >
        <PlasmicImg__
          data-plasmic-name={"img"}
          data-plasmic-override={overrides.img}
          alt={""}
          className={classNames(sty.img)}
          displayHeight={"100%"}
          displayMaxHeight={"none"}
          displayMaxWidth={"none"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"100%"}
          loading={"lazy"}
          src={(() => {
            try {
              return $props.dockButtonIcon.src;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()}
        />
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "iconWrapper", "img"],
  iconWrapper: ["iconWrapper", "img"],
  img: ["img"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOp1WebBgSpaceButton__ArgProps,
          internalVariantPropNames: PlasmicOp1WebBgSpaceButton__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOp1WebBgSpaceButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOp1WebBgSpaceButton";
  } else {
    func.displayName = `PlasmicOp1WebBgSpaceButton.${nodeName}`;
  }
  return func;
}

export const PlasmicOp1WebBgSpaceButton = Object.assign(
  // Top-level PlasmicOp1WebBgSpaceButton renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    iconWrapper: makeNodeComponent("iconWrapper"),
    img: makeNodeComponent("img"),
    // Metadata about props expected for PlasmicOp1WebBgSpaceButton
    internalVariantProps: PlasmicOp1WebBgSpaceButton__VariantProps,
    internalArgProps: PlasmicOp1WebBgSpaceButton__ArgProps
  }
);

export default PlasmicOp1WebBgSpaceButton;
/* prettier-ignore-end */
